@if (showNav()) {
  <app-nav />
  <app-status-bar />
}
<router-outlet />
<app-session-revoked-dialog />
<app-leave-confirm-dialog />
<app-toast-host />
<app-page-forbidden-notice />
